import { MutationTree } from "vuex";
import { AuthState } from "./auth.module";
import { MUTATIONS } from "@/constants/mutations";

export const AUTH_MUTATIONS: MutationTree<AuthState> = {
  // loading
  [MUTATIONS.auth.toggleLoading](state, loading: boolean): void {
    state.loading = loading;
  },
  // toggle authentication status
  [MUTATIONS.auth.toggleAuthenticationStatus](state, status: string): void {
    state.authentication = status;
  },
  
  // register form
  // update register mobile
  [MUTATIONS.auth.updateRegisterMobile](state, mobile: string): void {
    state.registerForm.mobile = mobile;
  },
  // update register password
  [MUTATIONS.auth.updateRegisterPassword](state, password: string): void {
    state.registerForm.password = password;
  },
  // update register confirm
  [MUTATIONS.auth.updateRegisterConfirm](state, confirm: string): void {
    state.registerForm.confirm = confirm;
  },
};
